// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description The other party entity of the transaction
*/
export class DigitalpaymentCounterpartyEntityDetail {
    'counterpartyEntityAliasId'?: string | null;
    'counterpartyEntityName'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalpaymentCounterpartyEntityDetail>> = [
        {
            "name":     "counterpartyEntityAliasId",
            "baseName": "counterpartyEntityAliasId",
            "type":     "string"
        },
        {
            "name":     "counterpartyEntityName",
            "baseName": "counterpartyEntityName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalpaymentCounterpartyEntityDetail.attributeTypeMap;
    }
}
